// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1Qju6","consentsList":"PatientConsents_consentsList__3CMQd","consentsListEmpty":"PatientConsents_consentsListEmpty__MRqtt"};